import { takeLatest, put, call } from "redux-saga/effects";

import { actions as transactionLinesActions } from "reducers/form/transactionLines";
import { types, actions } from "reducers/files";
import * as fileMiddleware from "middleware/file";
import * as downloadUtil from "util/download";
import { download } from "util/download";
import * as i18n from "util/i18n";
import * as configUtils from "util/config";
import { currencyFromSalaryPaymentAccountType, parseSalaryPaymentFileAmount } from "util/thirdPayment";

const sagas = [
    takeLatest(types.DOWNLOAD_FILE_REQUEST, downloadFileRequest),
    takeLatest(types.GET_FILE_CONTENTS_REQUEST, getFileContentsRequest),
    takeLatest(types.LOAD_ECHEQ_FILE_REQUEST, loadEcheqFileRequest),
];

export default sagas;

const fetchBlobData = async (url) => {
    let responseBlob;
    try {
        const response = await fetch(url);
        responseBlob = await response.blob();
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
    return responseBlob;
};

function* downloadFileRequest({ idFile }) {
    const fileResponse = yield call(fileMiddleware.download, idFile);
    const { fileName, content } = fileResponse.data.data;
    download(fileName, content);

    // solo para quitar el descargando
    yield put(actions.downloadFileSuccess());
}

function* getFileContentsRequest({ idFile, deleteFile, idUserCreator }) {
    let fileResponse;
    let blob;

    if (idUserCreator) {
        fileResponse = yield fileMiddleware.downloadStreamWithUser(idFile, idUserCreator);
        const base64 = fileResponse?.data?.data?.file?.contents;

        if (base64) {
            blob = yield fetchBlobData(`data:application/octet-stream;base64,${base64}`);
        }
    } else {
        fileResponse = yield fileMiddleware.downloadStream(idFile, null);
        const base64 = fileResponse?.data?.data?.file?.contents;

        if (base64) {
            blob = yield fetchBlobData(`data:application/octet-stream;base64,${base64}`);
        }

        blob = fileResponse.data;
    }

    const content =
        blob &&
        downloadUtil
            .getBlobContent(blob)
            .split("\n")
            .map((line, i) => {
                const [account, cbu, cuit, amount, voucher, motivo, referenc, reference] = line.split(";");
                const lineCurrency = currencyFromSalaryPaymentAccountType(account);
                return {
                    account,
                    cbu,
                    cuit,
                    creditAmountQuantity: parseSalaryPaymentFileAmount(amount),
                    creditAmountCurrency: lineCurrency,
                    currency: lineCurrency,
                    voucher,
                    motivo,
                    referenc,
                    reference,
                    lineNumber: i + 1,
                };
            });
    if (deleteFile) {
        yield fileMiddleware.deleteFile(Number(idFile));
    }

    const lines = content || [];
    if (lines.length > 0) {
        lines.pop();
    }
    yield put(transactionLinesActions.getFileContentsSuccess(lines));
}

function* loadEcheqFileRequest({ formData, load, onFileProcess, onError, error }) {
    const fileResponse = yield call(fileMiddleware.loadEcheqFile, formData);
    const response = fileResponse?.data;
    const FORM_ID = "echeq.massive.emit";
    let errorMessage = i18n.get("forms.notification.uploadFile.fail");
    const invalidFileErrorMessage = i18n.get(`forms.inputFile.${FORM_ID}.invalid.file.type`);
    if (response.code.endsWith("I")) {
        const { idFile, validLines, invalidLines, ...data } = response.data;
        const message =
            invalidLines !== 0
                ? i18n.get(`forms.inputFile.${FORM_ID}.invalid.file.errorLines`)
                : i18n.get(`forms.inputFile.${FORM_ID}.uploadFile.success`, null, {
                      VALID_LINES: validLines,
                      TOTAL_LINES: validLines,
                  });

        load(response.data.idFile);

        if (onFileProcess) {
            onFileProcess({ idFile, message, validLines, invalidLines, ...data });
        }
    } else if (response.code.endsWith("W")) {
        if (onError) {
            const { invalidLines } = response.data;
            const allowedEcheqs = configUtils.getInteger("frontend.MassiveEcheq.max.allowed.echeqs", 500);
            errorMessage =
                invalidLines && invalidLines > 0
                    ? i18n.get(`forms.inputFile.${FORM_ID}.invalid.file.maxLines`, null, {
                          ALLOWED_ECHEQS: allowedEcheqs,
                      })
                    : invalidFileErrorMessage;
            onError({ errorMessage, ...response.data });
        }
        error("warning");
    } else {
        if (onError) {
            onError({ errorMessage });
        }
        error("oh no");
    }
    yield put({
        type: types.LOAD_ECHEQ_FILE_SUCCESS,
        responseData: fileResponse?.data,
    });
}
